import React, { useEffect, useState } from "react";
import { fetchLatestLoginAgreement } from "../api/loginAgreementService";
import { createLoginAgreementConsent } from "../api/loginAgreementConsentService";
import { jwtDecode } from "jwt-decode";

const LoginAgreementPage = () => {
    const [agreement, setAgreement] = useState(null);
    const [checked, setChecked] = useState(false);
    const [loading, setLoading] = useState(true);
    const [submitLoading, setSubmitLoading] = useState(false);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(null);

    // 👉 Get loginId from JWT
    let loginId = null;
    try {
        const token = localStorage.getItem("token");
        if (token) {
            const decoded = jwtDecode(token);
            loginId = decoded.nameid || decoded.userId || decoded.sub;
        }
    } catch (e) {
        console.error("JWT decode error:", e);
    }

    useEffect(() => {
        const getAgreement = async () => {
            try {
                const data = await fetchLatestLoginAgreement();
                if (data && data.version && data.content) {
                    setAgreement(data);
                } else {
                    throw new Error("Invalid agreement data structure.");
                }
            } catch (err) {
                setError("Failed to fetch agreement.");
                console.error("Error fetching agreement:", err);
            } finally {
                setLoading(false);
            }
        };
        getAgreement();
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSubmitLoading(true);
        setSuccess(null);
        setError(null);

        if (!loginId) {
            setError("User is not authenticated.");
            setSubmitLoading(false);
            return;
        }

        try {
            await createLoginAgreementConsent({
                loginId: loginId,
                agreementId: agreement.id
            });

            setSuccess("Agreement accepted. Thank you!");
        } catch (err) {
            setError("Failed to submit consent.");
        } finally {
            setSubmitLoading(false);
        }
    };

    if (loading) return <p>Loading...</p>;
    if (error) return <p className="text-red-500">{error}</p>;

    return (
        <div className="page-container">
            <h1 className="text-2xl font-bold mb-4">Login Agreement</h1>

            {agreement ? (
                <form onSubmit={handleSubmit} className="prose max-w-full p-4">
                    <p><strong>Version:</strong> {agreement.version}</p>

                    <div dangerouslySetInnerHTML={{ __html: agreement.content }} />

                    <div className="my-4 flex items-center">
                        <input
                            type="checkbox"
                            id="agree"
                            checked={checked}
                            onChange={e => setChecked(e.target.checked)}
                            className="mr-2"
                        />
                        <label htmlFor="agree">
                            I accept the terms of the user agreement
                        </label>
                    </div>

                    <button
                        type="submit"
                        className="bg-blue-600 text-white px-4 py-2 rounded"
                        disabled={!checked || submitLoading}
                    >
                        {submitLoading ? "Confirm..." : "Confirm"}
                    </button>

                    {success && <p className="text-green-600 mt-2">{success}</p>}
                    {error && <p className="text-red-600 mt-2">{error}</p>}
                </form>
            ) : (
                <p>No agreement available.</p>
            )}
        </div>
    );
};

export default LoginAgreementPage;
